import {IdTokenResult} from 'firebase/auth'

import {PaymentPageQueryDataType} from '../pages/payment/payment-page'

export const getItemFromLocalStorage = (itemName: string) => localStorage.getItem(itemName)
export const removeItemFromLocalStorage = (itemName: string) => localStorage.removeItem(itemName)
export const setItemToLocalStorage = (itemName: string, itemValue: string) => localStorage.setItem(itemName, itemValue)

export const getAuthToken = () => {
  const result = localStorage.getItem('accessToken')
  if (result) {
    return JSON.parse(result) as IdTokenResult
  }
  return null
} // eslint-disable-line
export const setAuthToken = (token: IdTokenResult) => localStorage.setItem('accessToken', JSON.stringify(token)) // eslint-disable-line
export const removeAuthToken = () => localStorage.removeItem('accessToken') // eslint-disable-line

export const getAuthTokenFromSession = () => JSON.parse(sessionStorage.getItem('accessToken') || '') // eslint-disable-line
export const getPosPaymentInfoFromSession = ():Partial<PaymentPageQueryDataType> => {
  try {
    return JSON.parse(sessionStorage.getItem('posPaymentData') || '') // eslint-disable-line
  } catch (e) {
    return {}
  }
}
export const setPosPaymentInfoToSession = (data: PaymentPageQueryDataType) => sessionStorage.setItem('posPaymentData', JSON.stringify(data)) // eslint-disable-line
export const setAuthTokenToSession = (token: string) => sessionStorage.setItem('accessToken', JSON.stringify(token)) // eslint-disable-line
export const removeAuthTokenFromSession = () => sessionStorage.removeItem('accessToken') // eslint-disable-line

export const getRefreshTokenFromSession = () => JSON.parse(sessionStorage.getItem('refreshToken') || '') // eslint-disable-line
export const setRefreshTokenToSession = (token: string) => sessionStorage.setItem('refreshToken', JSON.stringify(token)) // eslint-disable-line
export const removeRefreshTokenFromSession = () => sessionStorage.removeItem('refreshToken') // eslint-disable-line

export const getToken = () => getAuthToken() as string | null || getAuthTokenFromSession() as string | null
